import script from "./CategoriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesList.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesList.vue?vue&type=style&index=0&id=4ec930e3&lang=css"

const __exports__ = script;

export default __exports__